import { observer } from 'mobx-react';
import React from 'react';
import { promocodeStore } from '../../store/promocodeStore';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types';
import TabPicker from 'src/view/components/Controls/Pickers/TabPicker/TabPicker';
import CustomersModalOpen from 'src/view/containers/Modals/CustomersModal/components/CustomersModalOpen/CustomersModalOpen';
import { ICustomersModalItem } from 'src/view/containers/Modals/CustomersModal/types';
import Text from '~/view/components/Text/Text';
import './style.scss';

enum PROMOCODE_CUSTOMERS_STATE {
  ALL,
  INCLUDED,
}

@observer
export default class PromocodeCustomers extends React.Component<{}, {}> {
  changeBranchesState = (key: string | number) => {
    promocodeStore.changePromocode({ allCustomers: key === PROMOCODE_CUSTOMERS_STATE.ALL ? true : false });
  };

  selectCustomers = (customers: ICustomersModalItem[] = []) => {
    promocodeStore.changePromocode({ customers });
  };

  get customersOptions(): IPickerOption[] {
    return [
      { value: PROMOCODE_CUSTOMERS_STATE.ALL, label: 'all' },
      { value: PROMOCODE_CUSTOMERS_STATE.INCLUDED, label: 'include' },
    ];
  }

  render() {
    return (
      <div className="mt-6">
        <Text type="block-header" text="customers" />
        <div className="promocode-customers d-flex flex-row align-items-center full-width mt-2">
          <TabPicker
            value={promocodeStore.promocode.allCustomers ? PROMOCODE_CUSTOMERS_STATE.ALL : PROMOCODE_CUSTOMERS_STATE.INCLUDED}
            options={this.customersOptions}
            onChange={this.changeBranchesState}
            className="mr-4"
          />
          {promocodeStore.promocode.allCustomers ? null : (
            <CustomersModalOpen selectedCustomers={promocodeStore.promocode.customers} onSave={this.selectCustomers} isMulti />
          )}
        </div>
      </div>
    );
  }
}
